import apicaller from "@/utils/apicaller";
import api from "../main.api";
export default {
    getRuleCandidates(req) {
        return apicaller.get(`${api.FRAUDRULES.candidates}/${req.selectedEntityId}/${req.selectedState}`);
    },
    getRules(selectedEntityId) {
        return apicaller.get(`${api.FRAUDRULES.getAll}/${selectedEntityId}`);
    },
    delete(id) {
        return apicaller.delete(`${api.FRAUDRULES.crud}/${id}`);
    },
    deleteCandidate(id) {
        return apicaller.delete(`${api.FRAUDRULES.candidates}/${id}`);
    },
    add(rule) {
        return apicaller.post(`${api.FRAUDRULES.crud}`, rule);
    },
    update(rule) {
        return apicaller.put(`${api.FRAUDRULES.crud}/${rule.ID}`, rule);
    },
    getByEntityId(payload) {
        return apicaller.post(`${api.FRAUDRULES.getByEntityId}`, payload);
    },
    changeCandidateState(rule) {
        return apicaller.put(`${api.FRAUDRULES.changeCandidateState}`, rule);
    },
    createRuleDeleteApprovalCandidate(ruleId) {
        return apicaller.put(`${api.FRAUDRULES.createRuleDeleteApprovalCandidate}/${ruleId}`);
    },
    getRuleSetHistoryByRuleSetId(ruleSetId) {
        return apicaller.get(`${api.FRAUDRULESETS.history}/${ruleSetId}`);
    }
}